/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useCallback } from "react";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { ERROR_TEXT } from "~/constants";
import { LOCAL_STORAGE } from "~/constants/localStorage";

const useShowError = () => {
  const showError = useCallback(
    (response: AxiosResponse, autoClose: false | number = 5000) => {
      const data = response?.data;
      const errorText = data?.error || data?.detail || ERROR_TEXT.default;

      !localStorage.getItem(LOCAL_STORAGE.refreshingToken) &&
        toast.error(errorText, {
          position: "top-right",
          autoClose,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          onClick: undefined,
        });
    },
    []
  );

  return { showError };
};

export { useShowError };
